import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20composition%20of%20a%20modern%20home%20theater%20entertainment%20setup%20with%20dramatic%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20floating%20glowing%20film%20strips%20and%20streaming%20visual%20elements%20in%20dark%20atmospheric%20space%2C%20professional%20entertainment%20platform%20atmosphere%2C%20sleek%20contemporary%20design%20with%20cinematic%20depth%2C%20rich%20warm%20tones%20against%20dark%20background%2C%20premium%20streaming%20service%20visual%20identity&width=1600&height=900&seq=hero-bg-91meiju&orientation=landscape"
        alt="91美剧网 - 最新美剧在线观看平台"
        title="91美剧网 - 美剧在线观看"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          最新美剧在线观看
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          专注美剧资源的在线追剧平台，涵盖动作、悬疑、科幻、爱情等多种类型，
          高清画质流畅播放，第一时间更新最新剧集，让追剧成为一种享受。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即追剧
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-lg bg-white/10 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/20 transition-colors border border-white/20 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          {[
            { num: '20+', label: '美剧分类' },
            { num: '1000+', label: '剧集资源' },
            { num: '99.9%', label: '流畅播放' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">{stat.num}</div>
              <div className="text-xs text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}